const equal = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const idKey = (r) =>
  r && typeof r === "object"
    ? r.id
      ? "id"
      : r.no
        ? "no"
        : r.code
          ? "code"
          : null
    : null;
/** Keep edits made during a save while accepting the server's canonical revision and audit history. */
export function rebaseSavedState(sent, local, remote) {
  const next = structuredClone(remote);
  for (const [key, value] of Object.entries(local)) {
    if (equal(value, sent[key])) continue;
    if (key === "audit") {
      next.audit = [...remote.audit, ...value.slice(sent.audit.length)];
      continue;
    }
    if (Array.isArray(value) && value.every(idKey)) {
      const index = new Map((next[key] || []).map((r) => [r[idKey(r)], r]));
      for (const row of value) {
        const field = idKey(row),
          before = sent[key]?.find((r) => r[field] === row[field]);
        if (equal(before, row)) continue;
        const existing = index.get(row[field]);
        if (!before) {
          index.set(row[field], structuredClone(row));
          continue;
        }
        const updated = { ...existing };
        for (const [field, value] of Object.entries(row))
          if (!equal(before[field], value))
            updated[field] = structuredClone(value);
        index.set(row[field], updated);
      }
      next[key] = [...index.values()];
    } else next[key] = structuredClone(value);
  }
  return next;
}
